export default __webpack_public_path__ + "static/media/makarayiz.9c4788c1.mp3";